import React from "react";
import { Link } from "react-router-dom";

const Card = ({ item }) => {

    const { fileName, description, previewUrl, streamUrl } = item;

    const previewLink = process.env.REACT_APP_BACKEND_SERVER_URL + previewUrl;
    const streamLink = process.env.REACT_APP_BACKEND_SERVER_URL + streamUrl;

    return (
        <div className="border justify-center items-center border-gray-300 rounded-lg p-4">
            <Link to="/stream" state={{ link: streamLink, name: fileName }}>
                <div className="flex justify-center py-2 ">
                    <img src={previewLink} alt={description} style={{ width: '250px', height: '125px' }} />
                </div>
            </Link>
            <div className="flex justify-center">
                <p className="py-2 text-center text-wrap">{fileName}</p>
            </div>
        </div>

    );
};

export default Card;
